var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 190,
    height: 59.751,
    viewBox: "0 0 190 59.751",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Logo",
    transform: "translate(-149 -154.025)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_3",
    "data-name": "Gruppe 3",
    transform: "translate(149 199.428)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_1",
    "data-name": "Gruppe 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_1",
    "data-name": "Pfad 1",
    d: "M155.876,158.612A6.856,6.856,0,0,0,149,165.438v.161a6.836,6.836,0,0,0,13.671.221v-.161l.04-.131a6.719,6.719,0,0,0-6.534-6.906A3.006,3.006,0,0,0,155.876,158.612Zm0,12.256a5.145,5.145,0,0,1-5.069-5.219l.01-.121a5.024,5.024,0,0,1,4.8-5.26l.221-.01a5.145,5.145,0,0,1,5.069,5.219l-.01.12a5.039,5.039,0,0,1-4.8,5.27Z",
    transform: "translate(-149 -158.197)",
    fill: "#820028"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_2",
    "data-name": "Pfad 2",
    d: "M157.742,164.679a2.731,2.731,0,0,1-2.54,2.911,1.924,1.924,0,0,1-.241.01,2.47,2.47,0,0,1-2.58-2.359,2.136,2.136,0,0,1,.02-.442v-5.822h-1.716v6.173a3.7,3.7,0,0,0,3.363,4.015,2.686,2.686,0,0,0,.492.01,3.712,3.712,0,0,0,3.2-1.6v1.4h1.7v-10h-1.7Z",
    transform: "translate(-133.902 -154.889)",
    fill: "#820028"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3",
    "data-name": "Pfad 3",
    d: "M154.888,158.685h-1.716v2.941h-1.355v1.546h1.355v5.741a2.59,2.59,0,0,0,2.279,2.881,3.022,3.022,0,0,0,.6,0,3.743,3.743,0,0,0,1.807-.421l.07-.04V169.8l-.191.09a2.754,2.754,0,0,1-1.355.321,1.3,1.3,0,0,1-1.5-1.094,1.217,1.217,0,0,1,0-.381v-5.551h3.081v-1.546h-3.081Z",
    transform: "translate(-123.541 -157.537)",
    fill: "#820028"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_4",
    "data-name": "Pfad 4",
    d: "M158.579,158.957a5.219,5.219,0,1,0,5.2,5.24v-.05a5.168,5.168,0,0,0-5.149-5.189Zm0,8.863a3.515,3.515,0,0,1-3.463-3.583v-.1a3.468,3.468,0,0,1,3.272-3.624h.151a3.539,3.539,0,0,1,3.483,3.613v.09a3.446,3.446,0,0,1-3.282,3.6Z",
    transform: "translate(-109.696 -155.079)",
    fill: "#820028"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_5",
    "data-name": "Pfad 5",
    d: "M159.008,158.574a3.008,3.008,0,0,0-2.178.793,3.616,3.616,0,0,0-.893,2.6v.713H154.6v1.526h1.335v8.451h1.726v-8.451h3.061V162.7h-3.082v-.662c0-1.315.492-1.927,1.556-1.927a4.557,4.557,0,0,1,1.375.241l.171.04v-1.536l-.09-.03A4.562,4.562,0,0,0,159.008,158.574Z",
    transform: "translate(-98.372 -158.571)",
    fill: "#820028"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_6",
    "data-name": "Pfad 6",
    d: "M165.2,164.487h-7.337v-5.852H156.11v13.45h1.757v-5.932H165.2v5.932h1.746v-13.45H165.2Z",
    transform: "translate(-84.743 -157.989)",
    fill: "#820028"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_7",
    "data-name": "Pfad 7",
    d: "M162.738,158.957a5.219,5.219,0,1,0,5.2,5.24v-.05a5.17,5.17,0,0,0-5.159-5.189Zm0,8.863a3.522,3.522,0,0,1-3.463-3.583l.01-.1a3.453,3.453,0,0,1,3.262-3.624h.151a3.554,3.554,0,0,1,3.493,3.613l-.01.09a3.446,3.446,0,0,1-3.282,3.6Z",
    transform: "translate(-72.109 -155.079)",
    fill: "#820028"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_8",
    "data-name": "Pfad 8",
    d: "M170.122,158.958a3.94,3.94,0,0,0-3.413,1.817,3.427,3.427,0,0,0-3.141-1.817,3.579,3.579,0,0,0-3,1.556v-1.345H158.84v10h1.726v-5.691a2.673,2.673,0,0,1,2.409-2.921l.161-.01c1.485,0,2.369,1.034,2.369,2.77v5.852h1.7v-5.742a2.569,2.569,0,0,1,2.258-2.861l.3-.02c1.516,0,2.389,1.024,2.389,2.8v5.822h1.716v-6.153C173.866,160.514,172.431,158.958,170.122,158.958Z",
    transform: "translate(-60.071 -155.08)",
    fill: "#820028"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_9",
    "data-name": "Pfad 9",
    d: "M165.441,158.957a4.927,4.927,0,0,0-4.818,5.019l.01.2a4.987,4.987,0,0,0,4.768,5.209,1.633,1.633,0,0,0,.221.01,5.173,5.173,0,0,0,4.115-1.877l.09-.1-1.1-.984-.09.09a3.893,3.893,0,0,1-2.971,1.335,3.245,3.245,0,0,1-3.282-2.961h7.689l.02-.12c.01-.231.01-.392.01-.522C170.1,161.085,168.221,158.957,165.441,158.957Zm-.04,1.5a3.046,3.046,0,0,1,2.951,3h-5.962a3.188,3.188,0,0,1,3-3Z",
    transform: "translate(-43.968 -155.079)",
    fill: "#820028"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_2",
    "data-name": "Gruppe 2",
    transform: "translate(134.784 0.084)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_10",
    "data-name": "Pfad 10",
    d: "M168.933,165.711l-4.8-7.076H162.5v13.45h1.716V161.727l4.657,6.735h.151l4.6-6.755v10.379h1.747v-13.45l-1.747.07Z",
    transform: "translate(-162.499 -158.073)",
    fill: "#820028"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_11",
    "data-name": "Pfad 11",
    d: "M168.909,158.957a4.919,4.919,0,0,0-4.808,5.019l.01.2a4.993,4.993,0,0,0,4.768,5.209c.07,0,.151.01.221.01a5.139,5.139,0,0,0,4.105-1.877l.09-.1-1.1-.984-.08.09a3.923,3.923,0,0,1-2.971,1.335,3.237,3.237,0,0,1-3.272-2.961h7.689l.01-.12c.02-.231.02-.392.02-.522C173.576,161.085,171.7,158.957,168.909,158.957Zm-.04,1.5a3.041,3.041,0,0,1,2.961,3h-5.962a3.188,3.188,0,0,1,3-3Z",
    transform: "translate(-148.031 -155.163)",
    fill: "#820028"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_12",
    "data-name": "Pfad 12",
    d: "M173.644,164.17a4.431,4.431,0,0,0-3.593-1.8,5.229,5.229,0,0,0,0,10.419,4.33,4.33,0,0,0,3.593-1.887v1.676h1.716v-14h-1.716Zm-3.323,7.056a3.383,3.383,0,0,1-3.312-3.443l.02-.231a3.3,3.3,0,0,1,3-3.593l.291-.02a3.49,3.49,0,0,1,3.393,3.563l-.01.09a3.511,3.511,0,0,1-3.383,3.634Z",
    transform: "translate(-137.419 -158.579)",
    fill: "#820028"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_1",
    "data-name": "Rechteck 1",
    width: 1.924,
    height: 1.869,
    transform: "translate(41.548 0.278)",
    fill: "#820028"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_2",
    "data-name": "Rechteck 2",
    width: 1.719,
    height: 9.999,
    transform: "translate(41.641 4.004)",
    fill: "#820028"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13",
    "data-name": "Pfad 13",
    d: "M174.893,160.086a4.419,4.419,0,0,0-3.232-1.114,8.156,8.156,0,0,0-3.6.843l-.11.05.532,1.445.131-.06a6.444,6.444,0,0,1,2.891-.683c1.807,0,2.75.863,2.75,2.5v.12a10.418,10.418,0,0,0-2.84-.371c-2.69,0-4.3,1.235-4.3,3.352,0,2.078,1.9,3.162,3.774,3.162a4.369,4.369,0,0,0,3.362-1.425v1.225h1.7v-6.083A3.961,3.961,0,0,0,174.893,160.086Zm-.622,4.527v.8c0,1.415-1.335,2.479-3.1,2.479-1.114,0-2.319-.562-2.319-1.847,0-1.124,1.044-1.817,2.71-1.817a9.555,9.555,0,0,1,2.71.381Z",
    transform: "translate(-120.791 -155.118)",
    fill: "#820028"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_6",
    "data-name": "Gruppe 6",
    transform: "translate(149.402 154.025)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_5",
    "data-name": "Gruppe 5",
    transform: "translate(46.174 13.775)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_4",
    "data-name": "Gruppe 4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_14",
    "data-name": "Pfad 14",
    d: "M171.867,164.423c-3.754-.963-4.677-1.425-4.677-2.851v-.06c0-1.064.954-1.887,2.78-1.887a8.773,8.773,0,0,1,4.216,1.245,2.093,2.093,0,0,0,1.034.271,1.537,1.537,0,0,0,1.3-.7h0l1.566-2.268a12.511,12.511,0,0,0-8.06-2.76c-4.426,0-7.588,2.6-7.588,6.534V162c0,4.316,2.82,5.521,7.187,6.635,3.633.933,4.366,1.546,4.366,2.75v.06c0,1.275-1.174,2.048-3.132,2.048a8.979,8.979,0,0,1-4.437-1.014c-1.124-.6-1.5-.833-1.977-.853a1.288,1.288,0,0,0-1.174.6h-.01l-.03.04-.01.02L161.6,174.27l.2.161a13.774,13.774,0,0,0,8.973,3.282c4.677,0,7.96-2.419,7.96-6.725v-.07C178.743,167.153,176.264,165.567,171.867,164.423Z",
    transform: "translate(-82.424 -155.303)",
    fill: "#c31423"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_15",
    "data-name": "Pfad 15",
    d: "M159.519,156.765h0Z",
    transform: "translate(-101.403 -143.038)",
    fill: "#c31423"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_16",
    "data-name": "Pfad 16",
    d: "M165.1,155.421h-6.866a2.086,2.086,0,0,0-2.007,1.8v20.045h4.778v-6.635h3.623c4.868,0,8.773-2.61,8.773-7.629v-.07C173.4,158.5,170.283,155.421,165.1,155.421Zm3.473,7.659c0,1.867-1.4,3.292-3.784,3.292h-3.784v-6.635H164.7c2.379,0,3.874,1.144,3.874,3.282Z",
    transform: "translate(-130.937 -155.184)",
    fill: "#c31423"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_17",
    "data-name": "Pfad 17",
    d: "M159.519,156.765h0Z",
    transform: "translate(-101.403 -143.038)",
    fill: "#c31423"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_3",
    "data-name": "Rechteck 3",
    width: 2.061,
    height: 21.868,
    transform: "translate(71.298 0.238)",
    fill: "#c31423"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_18",
    "data-name": "Pfad 18",
    d: "M167.412,155.421H164.06a2.084,2.084,0,0,0-1.466.994l-.2.472-8.682,20.386h4.878l1.977-4.858h9.174l1.465,3.573a1.964,1.964,0,0,0,1.847,1.285h3.664Zm-5.139,12.767,2.881-7.026,2.881,7.026Z",
    transform: "translate(-153.711 -155.184)",
    fill: "#c31423"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_19",
    "data-name": "Pfad 19",
    d: "M188.7,177.272l-9.295-21.851h-3.363a2.1,2.1,0,0,0-1.465.994l-.191.472-8.682,20.386h4.868l1.978-4.858h9.174l1.466,3.573a1.974,1.974,0,0,0,1.847,1.285Zm-14.444-9.084,2.881-7.026,2.891,7.026Z",
    transform: "translate(-45.281 -155.184)",
    fill: "#c31423"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_20",
    "data-name": "Pfad 20",
    d: "M171.72,165h-2.359v2.379h0a1.77,1.77,0,0,0,1.757,1.746h3.031v3.1a7.621,7.621,0,0,1-4.5,1.295,6.505,6.505,0,0,1-6.575-6.414c0-.161.01-.311.01-.462v-.07a6.529,6.529,0,0,1,6.233-6.755,7.542,7.542,0,0,1,3.925.964,2.944,2.944,0,0,0,1.425.532,1.958,1.958,0,0,0,1.506-.723c.05-.05.311-.371.311-.371L178,158.394a11.9,11.9,0,0,0-8.522-2.981,11.136,11.136,0,0,0-11.372,10.9c-.01.1-.01.211-.01.321v.06c0,6.414,4.657,11.162,11.412,11.162a14.081,14.081,0,0,0,9.264-3.443V165Z",
    transform: "translate(-114.055 -155.397)",
    fill: "#c31423"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_21",
    "data-name": "Pfad 21",
    d: "M177.14,165h-2.349v2.379h0a1.767,1.767,0,0,0,1.746,1.746h3.041v3.1a7.62,7.62,0,0,1-4.5,1.295,6.507,6.507,0,0,1-6.584-6.414c0-.161.01-.311.02-.462v-.07a6.514,6.514,0,0,1,6.223-6.755,7.639,7.639,0,0,1,3.925.964,2.942,2.942,0,0,0,1.425.532,1.928,1.928,0,0,0,1.506-.723l.3-.371,1.526-1.827a11.9,11.9,0,0,0-8.522-2.981,11.136,11.136,0,0,0-11.372,10.9c0,.11-.01.211,0,.321v.06c0,6.414,4.647,11.162,11.4,11.162a14.08,14.08,0,0,0,9.264-3.443V165Z",
    transform: "translate(-65.022 -155.397)",
    fill: "#c31423"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_22",
    "data-name": "Pfad 22",
    d: "M156.187,160.493a3.573,3.573,0,1,1-3.573-3.573,3.579,3.579,0,0,1,3.573,3.573Z",
    transform: "translate(-149.04 -127.862)",
    fill: "#c31423"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_23",
    "data-name": "Pfad 23",
    d: "M157.139,160.493a3.568,3.568,0,1,1-3.563-3.573,3.564,3.564,0,0,1,3.563,3.573Z",
    transform: "translate(-140.346 -127.862)",
    fill: "#c31423"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_24",
    "data-name": "Pfad 24",
    d: "M157.139,159.518a3.568,3.568,0,1,1-3.563-3.563h0A3.564,3.564,0,0,1,157.139,159.518Z",
    transform: "translate(-140.346 -136.583)",
    fill: "#c31423"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_25",
    "data-name": "Pfad 25",
    d: "M158.1,160.493a3.568,3.568,0,1,1-3.563-3.573A3.575,3.575,0,0,1,158.1,160.493Z",
    transform: "translate(-131.652 -127.862)",
    fill: "#c31423"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1",
    "data-name": "Ellipse 1",
    cx: 3.569,
    cy: 3.569,
    r: 3.569,
    transform: "translate(19.313 19.372)",
    fill: "#c31423"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_26",
    "data-name": "Pfad 26",
    d: "M158.1,158.553a3.568,3.568,0,1,1-3.573-3.563h.01A3.564,3.564,0,0,1,158.1,158.553Z",
    transform: "translate(-131.652 -145.304)",
    fill: "#c31423"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_27",
    "data-name": "Pfad 27",
    d: "M159.063,160.493a3.568,3.568,0,1,1-3.573-3.573,3.572,3.572,0,0,1,3.573,3.573Z",
    transform: "translate(-122.958 -127.862)",
    fill: "#c31423"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_28",
    "data-name": "Pfad 28",
    d: "M159.063,159.518a3.568,3.568,0,1,1-3.573-3.563h0a3.566,3.566,0,0,1,3.573,3.563Z",
    transform: "translate(-122.958 -136.583)",
    fill: "#c31423"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_29",
    "data-name": "Pfad 29",
    d: "M159.063,158.553a3.568,3.568,0,1,1-3.573-3.563h0a3.566,3.566,0,0,1,3.573,3.563Z",
    transform: "translate(-122.958 -145.304)",
    fill: "#c31423"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_30",
    "data-name": "Pfad 30",
    d: "M159.063,157.588a3.568,3.568,0,1,1-3.573-3.563h0a3.566,3.566,0,0,1,3.573,3.563Z",
    transform: "translate(-122.958 -154.025)",
    fill: "#c31423"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.a0e818d7a9252e0d3f852ede04416f36.svg";
export { ForwardRef as ReactComponent };